// extracted by mini-css-extract-plugin
module.exports = {"share":"Share_share__2SoXL","nativeShareButton":"Share_nativeShareButton__20VyT"};